<template>
    <div>
        <partner-list
                :partners="partners"
                v-on:selectedPartnerChanged="handlePartnerChange($event)"
        ></partner-list>
        <h2 v-if="partnerSelection">Ausgewählter Partner: {{partnerSelection.name}}</h2>
        <p>
            Wählen Sie nun Ihr Wunsch-Datum aus:
        </p>
        <form ref="form" novalidate method="post" action="/presence_appointment/saveAppointment" @submit.prevent.once="submit">
            <input type="hidden" v-if="partnerSelection" :value="partnerSelection.id" name="appointment_partner_id">
            <input type="hidden" :value="learning_unit_id" name="learning_unit_id">
            <input type="hidden" :value="appointment_id" name="appointment_id">

            <date-editor :max-dates="maxDates" :dateSelections="dateSelections" v-model="dateSelections"></date-editor>

            <slot>
                <csrf></csrf>
            </slot>

            <button :disabled="!canSubmit" type="submit" class="btn btn-success mt-3">Absenden</button>
        </form>
    </div>
</template>

<script>
export default {
    name: 'presence-appointment',
    props: {
        'action': String,
        'partners': Array,
        'appointment_id': String,
        'learning_unit_id': String,
        'maxDates': {
            type: Number,
            default: 2
        },
        'dates': {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    data() {
        return {
            'partnerSelection': this.partners[0],
            'dateSelections': this.dates,
        }
    },
    methods: {
        handlePartnerChange: function (data) {
            this.partnerSelection = data
        },
        submit: function (e) {
            this.$refs.form.submit();
        }
    },
    computed: {
        canSubmit(){
            return this.dateSelections.length >= 2;
        }
    }
}
</script>
